import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError, TimeoutError } from 'rxjs';
import { AuthService } from './auth.service';
import { GlobalErrorHandler } from '../error';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(private _authService: AuthService, private injector: Injector) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    // if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
    if (this._authService.accessToken) {
      newReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          'bearer ' + this._authService.accessToken
        ),
      });
    }

    // Response
    return next.handle(newReq).pipe(
      // timeout(3000),
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error instanceof TimeoutError) {
          new GlobalErrorHandler(this.injector).handleError(error);
          this._authService.signOut();
          return throwError(() => error);
        } else if (error instanceof HttpErrorResponse && error.status === 401) {
          new GlobalErrorHandler(this.injector).handleError(error);
          // Sign out
          this._authService.signOut();
          // Reload the app
          //location.reload();
          return throwError(() => error);
        }
        //else if (error instanceof HttpErrorResponse) {
        //   new GlobalErrorHandler(this.injector).handleError(error);
        //   // Sign out
        //   this._authService.signOut();

        //   // Reload the app
        //   location.reload();
        // } else {
        //   new GlobalErrorHandler(this.injector).handleError(error);
        //   // Sign out
        //   this._authService.signOut();
        //   // Reload the app
        //   location.reload();
        // }
        return throwError(() => {
          new GlobalErrorHandler(this.injector).handleError(error);
          return error;
        });
      })
    );
  }
}
